<template>
	<detail :id="id" verify></detail>
</template>

<script>
	import detail from './coupon_detail.vue'
	
	export default {
		name: 'coupon_verify',
		
		components: {
			detail
		},
		
		props: {
			id: String
		}
	}
</script>